module.exports = __webpack_public_path__ + "static/media/21ECLAC13.bf10b168.jpg";